import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { UserService } from './user.service';
import { resolve } from 'url';

const config = {
	instanceUrl: 'https://backend01.allbytes.net',
	userUrl: '/api/v2/user/session',
	registerUrl: '/api/v2/user/register',
	tableUrl: '/api/v2/mysql/_table/',
	headers: {
			'Content-Type': 'application/json; charset=utf-8',
			'Cache-Control':'no-cache',
			'X-DreamFactory-API-Key': '1c84b2b4531fb75650c6ffb8bf28458b4193e365fe8a9c3fb0d1c16b22fcae05',
			//'X-DreamFactory-Session-Token' : null
	}   
}

@Injectable()
export class VideoService {

	constructor(
		private http: HttpClient,
		private userService: UserService
	) { }

	getVideoRecords(table){
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = '';
		return new Promise((resolve,reject)=>{
			this.http.get(
				config.instanceUrl + config.tableUrl + table,
				{headers: new HttpHeaders(headers)}
			).subscribe((data: any)=>{
				if(data.hasOwnProperty('resource')){
					resolve(data.resource);
				}
				resolve(null)
			},(err)=>{
				reject(err)
			})
		})		
	}

	getVideoList(){
		return new Promise((resolve,reject)=>{
			Promise.all([
				this.getVideoRecords('categories'),
				this.getVideoRecords('exercises'),
				this.getVideoRecords('categories_exercises'),
				this.getVideoRecords('keyfacts'),
				this.getVideoRecords('exercise_bundles'),
				this.getVideoRecords('bundles_exercises_relation'),
				this.getVideoRecords('sub_categories'),
				this.getVideoRecords('categories_sub_categories'),
				this.getVideoRecords('sub_categories_exercises'),
			]).then((videoData: Array<any>)=>{

				let categories:Array<any> = videoData[0];
				let exercises :Array<any> = videoData[1];
				let categoriesAndExercises:Array<any> = videoData[2];
				let keyfacts:Array<any> = videoData[3];
				let bundles:Array<any> = videoData[4];
				let bundlesAndExercises:Array<any> = videoData[5];
				let subCategories:Array<any> = videoData[6];
				let subAndCategories:Array<any> = videoData[7];
				let subCategoriesAndExercises:Array<any> = videoData[8];

				// Add Keyfacts to Exercises
				let exercisesKeyfacts = exercises.map((exercise)=>{
					let keyfactsExercise = keyfacts.filter((keyfact)=>{
						return exercise.id === keyfact.exerciseId;
					})
					exercise.posterUrl = exercise.url.replace('.mp4','.jpg'),
					exercise.keyfacts = keyfactsExercise;
					return exercise;
				})

				let exercisesBundles = exercisesKeyfacts.map((exercise)=>{
					let exerciseBundles = bundlesAndExercises.filter((bundle)=>{
						return exercise.id === bundle.exerciseId;
					})


					let bundleList = [];
					exerciseBundles.forEach((bundleRelation)=>{
						let exerciseBundle = bundles.find((bundle)=>{
							return bundleRelation.bundleId === bundle.id;
						})
						bundleList.push(exerciseBundle);					

					})					
					exercise.bundles = bundleList;
					return exercise;
				})

				let exampleExercises = this.getExampleVideos(exercisesBundles)

				localStorage.setItem('exampleExercises', JSON.stringify(exampleExercises));
				localStorage.setItem('exercises', JSON.stringify(exercisesBundles));

				// Add Exercises to Subcategories
				let subWithExercises = subCategories.map((subCategorie)=>{
					let videoList = subCategoriesAndExercises.filter((subCategorieAndExercise)=>{
						return subCategorieAndExercise.sub_categorieId === subCategorie.id; // current sub-categorie
					})

					let exerciseList = [];
					videoList.forEach((video)=>{
						let exercise = exercisesBundles.find((exercise)=>{
							return video.exerciseId === exercise.id;
						})
						exercise.sequenceNumber = video.sequenceNumber;
						exerciseList.push(exercise);					
					})

					exerciseList.sort(function (a, b) {
						if (a.sequenceNumber > b.sequenceNumber) {
							return 1;
						}
						if (a.sequenceNumber < b.sequenceNumber) {
							return -1;
						}
						// a muss gleich b sein
						return 0;
					});

					subCategorie.exercises = exerciseList;
					return subCategorie;
				})

				// Add Exercises and Sub-Categories to Categories
				let completeVideoList = categories.map((categorie)=>{
					// Add Exercises
					let videoList = categoriesAndExercises.filter((categorieAndExercise)=>{
						return categorieAndExercise.categorieId === categorie.id; // current categorie
					})

					let exerciseList = [];
					videoList.forEach((video)=>{
						let exercise = exercisesBundles.find((exercise)=>{
							return video.exerciseId === exercise.id;
						})
						exercise.sequenceNumber = video.sequenceNumber;
						exerciseList.push(exercise);					

					})

					// Add Sub-Categories
					let subCategorieList = subAndCategories.filter((subAndCategorie)=>{
						return subAndCategorie.categorieId === categorie.id; // current categorie
					})

					subCategorieList.forEach((subCategorieH)=>{
						let subCategorie = subCategories.find((subCat)=>{
							return subCategorieH.sub_categorieId === subCat.id;
						})
						subCategorie.sequenceNumber = subCategorieH.sequenceNumber;
						subCategorie.isSubCategorie = true;
						exerciseList.push(subCategorie);	
					})


					exerciseList.sort(function (a, b) {
						if (a.sequenceNumber > b.sequenceNumber) {
						  return 1;
						}
						if (a.sequenceNumber < b.sequenceNumber) {
						  return -1;
						}
						// a muss gleich b sein
						return 0;
					});

					categorie.exercises = exerciseList;
					return categorie;
				})

				localStorage.setItem('videoList', JSON.stringify(completeVideoList))
				resolve(completeVideoList);
			},(err)=>{
				console.log("Video List could not be Downloaded!!")
				reject(err)
			})
		});
	}

	getExercises(){
		return new Promise((resolve,reject)=>{
			Promise.all([
				this.getVideoRecords('exercises'),
				this.getVideoRecords('keyfacts')
			]).then((videoData: Array<any>)=>{				
				let exercises :Array<any> = videoData[0];
				let keyfacts:Array<any> = videoData[1];
				
				let exercisesPayed = exercises.filter((exercise)=>{
					return !exercise.is_always_free
				})

				// Add Keyfacts to Exercises
				let exercisesKeyfacts = exercisesPayed.map((exercise)=>{
					let keyfactsExercise = keyfacts.filter((keyfact)=>{
						return exercise.id === keyfact.exerciseId;
					})
					exercise.posterUrl = exercise.url.replace('mp4','jpg');
					exercise.keyfacts = keyfactsExercise;
					
					return exercise;
					
				})
				exercisesKeyfacts.sort(function (a, b) {
					if (a.sequenceNumber > b.sequenceNumber) {
					  return 1;
					}
					if (a.sequenceNumber < b.sequenceNumber) {
					  return -1;
					}
					// a muss gleich b sein
					return 0;
				});	

                resolve(exercisesKeyfacts);
            },(err)=>{
                console.log("Video List could not be Downloaded!!")
                reject(err)
            })
        }) 		
	}
	
	getExercise(id){
		return new Promise((resolve,reject)=>{
			Promise.all([
				this.getVideoRecords('exercises'),
				this.getVideoRecords('keyfacts'),
				this.getVideoRecords('exercise_bundles'),
				this.getVideoRecords('bundles_exercises_relation'),
			]).then((videoData: Array<any>)=>{
		
				let exercises:Array<any> = videoData[0];
				let keyfacts :Array<any> = videoData[1];
				let bundles:Array<any> = videoData[2];
				let bundlesAndExercises:Array<any> = videoData[3];
				
				let currentExercise = exercises.find((exercise)=>{
					return exercise.id === id;
				})
				let keyfactsExercise = keyfacts.filter((keyfact)=>{
					return currentExercise.id === keyfact.exerciseId;
				})		
				
				let exerciseBundle = bundlesAndExercises.find((bundle)=>{
					return currentExercise.id === bundle.exerciseId;
				})

				if(exerciseBundle){
					let bundleRelation = bundlesAndExercises.find((bundle)=>{
						return exerciseBundle.exerciseId === bundle.exerciseId;
					})
					if(bundleRelation){
						let bundle = bundles.find((bundle)=>{
							return bundle.id = bundleRelation.bundleId;
						})
						if(bundle){
							currentExercise.bundle = bundle;
						}
					}
				}

				currentExercise.keyfacts = keyfactsExercise	

				resolve(currentExercise);
			})	
		})
	}


	checkFreeVideoInCategorie(categorie){

		let freeVideo = categorie.exercises.find((exercise)=>{
			return exercise.free === true;
		})

		let allFreeVideo = categorie.exercises.find((exercise)=>{
			return exercise.is_always_free === true
		})

		if(freeVideo && !allFreeVideo){
			return true;
		}else{
			return false;
		}
	}

	getFromLocalStorage(key: string) {
		let items = JSON.parse(localStorage.getItem(key));
		let parsedItems: Array<string> = [];
		if(items){
			items.forEach((value)=>{
				let parsedValue;
				try {
					parsedValue = JSON.parse(value);
				}catch(e){
					parsedValue = value;
				}
				parsedItems.push(parsedValue);
			})
			return items;
		}
	}	

	getBoughtVideos(){
		const boughtVideos = this.getFromLocalStorage("boughtVideos")  || [];
		const videoList = this.getFromLocalStorage("videoList");
		const boughtBundles = JSON.parse(localStorage.getItem("boughtBundles"))  || [] ;

		for(let i = 0; i < videoList.length; i++){
			let unlockedVideos = []
			videoList[i].exercises = this.recurCheckVideoBought(videoList[i],unlockedVideos,boughtVideos,boughtBundles);
		}
		return videoList;
	}

	recurCheckVideoBought(videoList,unlockedVideos,boughtVideos,boughtBundles){
		videoList.exercises.forEach(exercise => {
			if(exercise.isSubCategorie) {
				this.recurCheckVideoBought(exercise,unlockedVideos,boughtVideos,boughtBundles)
			}else{
				let isBought = false;
				if(exercise.free){
					isBought = true;
				}else{
					boughtVideos.forEach((boughtItem)=>{
						if(exercise.purchaseId === boughtItem.purchaseId){
							isBought = true;
						}
					})
		
					boughtBundles.forEach((boughtBundle)=>{
						if(exercise.bundles){
							exercise.bundles.forEach((bundle)=>{
								if(bundle.purchase_id === boughtBundle.purchaseId){
									isBought = true;
								}
							})
						}
		
					})							
				}
				if(isBought){
					unlockedVideos.push(exercise);
				}				
				
			}
		});
		return unlockedVideos;
	}

	setAllBoughtVideos(boughtVideoList: any){
		return localStorage.setItem('boughtVideos', JSON.stringify(boughtVideoList));
	}
	
	getExercisesByBundleId(bundleId){
		const exercises = JSON.parse(localStorage.getItem("exercises"));

		console.log(exercises)
		console.log(bundleId)
		let bundleExercises = exercises.filter((exercise)=>{
			let bundleExercise = exercise.bundles.find((bundle)=>{
				return bundle.id == bundleId;
			})
			if(bundleExercise){
				return true;
			}
			return false;
		})
		console.log(bundleExercises)
		return bundleExercises ;

	}

	getExerciseByCategoryId(categorieId){
		const videoList = JSON.parse(localStorage.getItem("videoList"));
		console.log(videoList)
		let exerciseList = []
		

		let recurFunc = function recurExerciseInCategorie(categorie){
			if(categorie.exercises){
				categorie.exercises.forEach((exercise)=>{
					recurFunc(exercise);
				})
			}else{
				exerciseList.push(categorie);
			}
		}

		videoList.forEach((categorie)=>{
			if(categorie.id == categorieId){
				recurFunc(categorie);
			}
		})
		return exerciseList;
	}



	getExampleVideos(exercises){
		return exercises.filter((exercise)=>{
			return exercise.free && !exercise.is_always_free; 
		})
	}

	setPriceList(priceList){
		return localStorage.setItem('priceList', JSON.stringify(priceList));
	}

/*
	checkIfVideoBought(exercise){
		return new Promise((resolve,reject)=>{
			let isBought = false;
			let user = JSON.parse(localStorage.getItem("user"));
			
			this.userService.getRecords('bought_videos',user.session_token).then((boughtVideos: Array<any>)=>{
				if(boughtVideos){
					isBought = boughtVideos.find((boughtVideo)=>{
						return exercise.purchaseId == boughtVideo.purchaseId;
					})
				}
				resolve(isBought);
			},(err)=>{
				reject(err);
			})
		})
	}
*/
	async checkIfVideoBought(exercise){		
		let buyStatus = {
			videoBought : false,
			bundleBought: false,
			boughtVideosCounter: 0,
			bundlesBought: []
		};

		let user = JSON.parse(localStorage.getItem("user"));
		let boughtVideos: any = await this.userService.getRecords('bought_videos',user.session_token);
		buyStatus.boughtVideosCounter = boughtVideos.length;

		if(boughtVideos){
			let video = boughtVideos.find((boughtVideo)=>{
				return exercise.purchaseId == boughtVideo.purchaseId;
			})
			if(video !== undefined || exercise.free){
				buyStatus.videoBought = true;
			}
		}

		let boughtBundles: any = await this.userService.getRecords('bought_bundles',user.session_token);

		if(boughtBundles){
			let bundle = boughtBundles.forEach((boughtBundle)=>{
				if(exercise.bundle){
					exercise.bundle.forEach(element => {
						if(element.purchase_id === boughtBundle.purchaseId){
							buyStatus.bundleBought = true;
							
						}
					});
				}

			})
		}

		return buyStatus;

	}	
	

	checkIfVideoFavorite(exercise){
		return new Promise((resolve,reject)=>{
			let isFavorite = false;
			let user = JSON.parse(localStorage.getItem("user"));
			
			this.userService.getRecords('favorites',user.session_token).then((favorites: Array<any>)=>{
				if(favorites){
					isFavorite = favorites.find((favorite)=>{
						return exercise.id == favorite.exerciseId;
					})
				}
				resolve(isFavorite);
			},(err)=>{
				reject(err);
			})
		})
	}	
}



// WEBPACK FOOTER //
// ./src/app/services/video.service.ts